import axios from "axios";

export const fetchUserIPApi = async (): Promise<string> => {
  const response = await axios.get("https://api64.ipify.org?format=json");
  return response.data.ip;
};
